const FlatButton = ({onClick, ...props}) => {
    return <button className="btn btn-flat" {...props} onClick={onClick}></button>
}

export default FlatButton